import { setDefaultOptions } from 'date-fns';
import { getLanguageCode } from '~shared/utils/user';


const DATE_FNS_MAPPING = {
    'ara': () => import(
        /* webpackChunkName: "date-fns-locales/ar" */
        'date-fns/locale/ar'
    ),
    'dan': () => import(
        /* webpackChunkName: "date-fns-locales/da" */
        'date-fns/locale/da'
    ),
    'deu': () => import(
        /* webpackChunkName: "date-fns-locales/de" */
        'date-fns/locale/de'
    ),
    'esp': () => import(
        /* webpackChunkName: "date-fns-locales/es" */
        'date-fns/locale/es'
    ),
    'fin': () => import(
        /* webpackChunkName: "date-fns-locales/fi" */
        'date-fns/locale/fi'
    ),
    'fra': () => import(
        /* webpackChunkName: "date-fns-locales/fr" */
        'date-fns/locale/fr'
    ),
    'nld': () => import(
        /* webpackChunkName: "date-fns-locales/nl" */
        'date-fns/locale/nl'
    ),
    'por': () => import(
        /* webpackChunkName: "date-fns-locales/pt" */
        'date-fns/locale/pt'
    ),
    'ron': () => import(
        /* webpackChunkName: "date-fns-locales/ro" */
        'date-fns/locale/ro'
    ),
    'rus': () => import(
        /* webpackChunkName: "date-fns-locales/ru" */
        'date-fns/locale/ru'
    ),
    'spa': () => import(
        /* webpackChunkName: "date-fns-locales/es" */
        'date-fns/locale/es'
    ),
    'swe': () => import(
        /* webpackChunkName: "date-fns-locales/sv" */
        'date-fns/locale/sv'
    ),
    // Don't load anything.
    // We use `en-US` as our locale for eng (not `en-GB` or `en-IE`)
    // and date-fns always load `en-US` locale by default so we don't need to load it again.
    'eng': () => Promise.resolve({ default: null }),
    'enu': () => Promise.resolve({ default: null }),
};

export const setupDateFns = async () => {
    const lng = getLanguageCode();

    try {
        const { default: data } = await DATE_FNS_MAPPING[lng]();
        // @see https://date-fns.org/v3.3.1/docs/setDefaultOptions
        if (data) {
            setDefaultOptions({ locale: data });
        }
    } catch (err) {
        console.error( //eslint-disable-line
            `Could not load date-fns locales for [${lng}].`
        );
    }
};
